import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps, getDayOptions } from "../../../../../utils/form-fields";

import Select from "../../../controls/Select";

const getYearOptions = () => {
  const startYear = new Date().getFullYear() - 1900;

  return Array.from(new Array(startYear + 2), (_, i) => {
    return { value: 1900 + i, title: `${1900 + i}` };
  });
};

function DatesBlock({ prefix = "startDate", values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Dates</span>
        </div>
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.baseDateMonth.replace("baseDate", prefix))}
          value={values[FORM_FIELD_KEYS.baseDateMonth.replace("baseDate", prefix)]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.baseDateDay.replace("baseDate", prefix))}
          value={values[FORM_FIELD_KEYS.baseDateDay.replace("baseDate", prefix)]}
          validated={values.validated}
          options={getDayOptions({
            year: values[FORM_FIELD_KEYS.baseDateYear.replace("baseDate", prefix)],
            month: values[FORM_FIELD_KEYS.baseDateMonth.replace("baseDate", prefix)],
          })}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.baseDateYear.replace("baseDate", prefix))}
          options={getYearOptions()}
          value={values[FORM_FIELD_KEYS.baseDateYear.replace("baseDate", prefix)]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.closingMonth)}
          value={values[FORM_FIELD_KEYS.closingMonth]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default DatesBlock;
